export default __webpack_public_path__ + "static/media/param_rpm.0906202f.svg";